<template>
  <!-- begin:: Aside -->
  <div class="brand flex-column-auto" id="kt_brand" ref="kt_brand">
    <div class="brand-logo">
      <router-link to="/">
        <img :src="siteLogo()" alt="Logo" class="img-logo" />
      </router-link>
    </div>
    <div class="brand-tools" v-if="allowMinimize">
      <button
        class="brand-toggle p-1 border rounded-circle"
        id="kt_aside_toggle"
        ref="kt_aside_toggle"
        @click="onToggleClick"
      >
        <span class="svg-icon svg-icon mr-0 ml-0">
          <inline-svg
            class="svg-icon mr-0 ml-0"
            src="/media/svg/icons/Navigation/Angle-double-left.svg"
          />
        </span>
      </button>
    </div>
  </div>
  <!-- end:: Aside -->
</template>

<style lang="scss" scoped>
.aside-toggle {
  outline: none;
}
.img-logo {
  max-width: 100px;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import KTLayoutBrand from '@/assets/js/layout/base/brand.js';
import KTLayoutAsideToggle from '@/assets/js/layout/base/aside-toggle.js';

export default {
  name: 'KTBrand',
  mounted() {
    KTLayoutBrand.init(this.$refs['kt_brand']);
    KTLayoutAsideToggle.init(this.$refs['kt_aside_toggle']);

    // Responsive: nếu màn hình nhỏ thì auto mini sidebar
    if (window.innerWidth <= 1366) {
      this.toggleSidebar(false);
      const toggle = KTLayoutAsideToggle.getToggle();
      if (toggle) toggle.toggleOn();
    }
  },
  methods: {
    ...mapActions('layout', ['toggleSidebar']),
    siteLogo() {
      return process.env.BASE_URL + (
        this.isToggleSidebar
          ? this.layoutConfig('loader.logo')          // sidebar mở
          : this.layoutConfig('loader.logo-minimize') // sidebar mini
      );
    },
    onToggleClick() {
      this.toggleSidebar(!this.isToggleSidebar);
    }
  },
  computed: {
    ...mapGetters(['layoutConfig']),
    ...mapGetters('layout', ['isToggleSidebar']),
    allowMinimize() {
      return !!this.layoutConfig('aside.self.minimize.toggle');
    }
  },
  watch: {
    // Đồng bộ Vuex <-> UI class của aside
    isToggleSidebar(newVal) {
      const toggle = KTLayoutAsideToggle.getToggle();
      if (!toggle) return;

      if (newVal) {
        toggle.toggleOff(); // sidebar mở
      } else {
        toggle.toggleOn();  // sidebar mini
      }
    }
  }
};
</script>
